import * as Yup from 'yup'
import type { TFunction } from 'i18next'

import { GrantProgramCandidateRule } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'
import { currencyCodes } from '@percent/utility'

export const getBaseProgramValidation = (t: TFunction) => ({
  opensAt: Yup.date().nullable().optional(),
  closesAt: Yup.date()
    .nullable()
    .optional()
    .when('opensAt', {
      is: (opensAt: Date | null) => opensAt != null,
      then: schema => schema.min(Yup.ref('opensAt'), t('grants.program.modal.errorMessage.dateMustBeAfter') as string)
    }),
  budgetMin: Yup.number()
    .min(0, t('errorMessage.mustBePositiveNumber') as string)
    .optional()
    .nullable(),
  budgetMax: Yup.number()
    .min(0, t('errorMessage.mustBePositiveNumber') as string)
    .when('budgetMin', {
      is: (budgetMin: number | null) => budgetMin != null,
      then: schema =>
        schema.min(Yup.ref('budgetMin'), t('grants.program.modal.errorMessage.budgetMaxMustBeGreaterThanMin') as string)
    })
    .optional()
    .nullable(),
  currency: Yup.string()
    .oneOf([...currencyCodes, null] as const)
    .nullable()
    .optional(),
  nominationDeadline: Yup.date().nullable().optional(),
  nonprofitCcEmail: Yup.string()
    .email(t('errorMessage.invalidEmail') as string)
    .nullable()
    .optional(),
  candidateRule: Yup.mixed<GrantProgramCandidateRule>()
    .oneOf([GrantProgramCandidateRule.UNIQUE_PER_ORG, GrantProgramCandidateRule.UNIQUE_PER_NOMINATION])
    .default(GrantProgramCandidateRule.UNIQUE_PER_ORG)
    .optional(),
  shareNominatorInfoWithOrg: Yup.boolean().optional()
})
